export default __webpack_public_path__ + "static/media/pettycash.3c8d3ca5.png";